export default [
	'15',
	'20',
	'25',
	'30',
	'Interest Only'
];